/**
 * IOC Blocklist types — mirror `/admin/iocs` wire shapes
 * (LOVABLE_TODO.md 2026-06-06).
 */

export type IocKind = "sha256" | "md5" | "ip" | "domain" | "cert_sha1";

export type IocSeverity = "info" | "low" | "medium" | "high" | "critical";

/** Source families: backend writes `threatintel:<feed>`, `manual:<email>`,
 *  or `playbook:<name>`. The UI groups by family prefix. */
export type IocSourceFamily = "threatintel" | "manual" | "playbook" | "other";

export interface IocRecord {
  id: string;
  tenantId?: string;
  kind: IocKind;
  value: string;
  severity: IocSeverity;
  source: string;
  reference?: string;
  note?: string;
  createdAt: string;
  createdBy?: string;
}

export interface CreateIocInput {
  kind: IocKind;
  value: string;
  severity: IocSeverity;
  source?: string;
  reference?: string;
  note?: string;
}

export interface IocBulkResult {
  count: number;
  results: Array<{
    index: number;
    value?: string;
    ok: boolean;
    error?: string;
    id?: string;
  }>;
}

export function iocSourceFamily(source: string | undefined): IocSourceFamily {
  if (!source) return "other";
  if (source.startsWith("threatintel:")) return "threatintel";
  if (source.startsWith("manual:")) return "manual";
  if (source.startsWith("playbook:")) return "playbook";
  return "other";
}
